import type { IconButtonProps } from '@mui/material/IconButton';

import { useState, useCallback } from 'react';

import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import MenuList from '@mui/material/MenuList';
import MenuItem, { menuItemClasses } from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';
import { langs } from '../../helpers/selectOptions';

// ----------------------------------------------------------------------

export type LanguagePopoverProps = IconButtonProps & {
  handleClosePopover: () => void,
  anchorElement : HTMLElement | null

};
type Language = {
    value: string[];
    label: string;
    src: string;
}



export function LanguagePopover({ sx,anchorElement ,handleClosePopover }: LanguagePopoverProps) {

  const { i18n } = useTranslation();

  const handleChangeLang = useCallback(
    (newLang: string) => {
     i18n.changeLanguage(newLang);
      handleClosePopover();
    },
    []
  );

 
  const currentLang = langs.find((c) => c.value.includes(i18n.language));

  const renderFlag = (label?: string, icon?: string) => (
    <Box
      component="img"
      alt={label}
      src={icon}
      sx={{ width: 26, height: 20, borderRadius: 0.5, objectFit: 'cover' }}
    />
  );
  return (
    <>
      {/* <IconButton
        onClick={handleOpenPopover}
        sx={{
          width: 40,
          height: 40,
          ...(openPopover && { bgcolor: 'action.selected' }),
          ...sx,
        }}
        {...other}
      > */}
       
      {/* </IconButton> */}

      <Popover
        open={anchorElement == null ? false : true}
        anchorEl={anchorElement}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuList
          disablePadding
          sx={{
            p: 0.5,
            gap: 0.5,
            width: 160,
            display: 'flex',
            flexDirection: 'column',
            [`& .${menuItemClasses.root}`]: {
              px: 1,
              gap: 2,
              borderRadius: 0.75,
              [`&.${menuItemClasses.selected}`]: {
                bgcolor: 'action.selected',
                fontWeight: 'fontWeightSemiBold',
              },
            },
          }}
        >
          {langs?.sort((a, b) => a.label.localeCompare(b.label)).map((option : Language ) => (
            <MenuItem
              key={option.value[0]}
              selected={option.value === currentLang?.value}
              onClick={() => handleChangeLang(option.value[0])}
            >
              {renderFlag(option.label, option.src)}
              {option.label}
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
    </>
  );
}
